var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewWindow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7308 0.769226H11.3846C11.0769 0.769226 10.7692 0.961534 10.7692 1.26923V2.42307C10.7692 2.73076 11.0385 3.07692 11.3846 3.07692H14.4231C14.7692 3.07692 14.9615 3.46153 14.6923 3.6923L8.15385 10.2308C7.92308 10.4615 7.92308 10.8077 8.15385 11.0385L8.96154 11.8461C9.19231 12.0769 9.53847 12.0769 9.76924 11.8461L16.3077 5.30769C16.5385 5.07692 16.9231 5.23076 16.9231 5.57692V8.61538C16.9231 8.92307 17.2308 9.26923 17.5385 9.26923H18.6539C18.9615 9.26923 19.2308 8.92307 19.2308 8.61538V1.30769C19.2308 0.961534 19.0385 0.769226 18.7308 0.769226Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9615 9.80769L12.6538 11.1538C12.4231 11.3846 12.3077 11.6538 12.3077 11.9615V16.3462C12.3077 16.6538 12.0385 16.9231 11.7308 16.9231H3.65384C3.34615 16.9231 3.07692 16.6538 3.07692 16.3462V8.26923C3.07692 7.96154 3.34615 7.69231 3.65384 7.69231H8.07692C8.38461 7.69231 8.6923 7.57692 8.88461 7.34615L10.1923 6.03846C10.4231 5.80769 10.2692 5.38461 9.92307 5.38461H2.30769C1.46153 5.38461 0.769226 6.07692 0.769226 6.92307V17.6923C0.769226 18.5385 1.46153 19.2308 2.30769 19.2308H13.0769C13.9231 19.2308 14.6154 18.5385 14.6154 17.6923V10.0769C14.6154 9.73077 14.1923 9.57692 13.9615 9.80769Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewWindow);
export default __webpack_public_path__ + "static/media/new_window.019db051.svg";
export { ForwardRef as ReactComponent };